import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { BUSINESS, IMAGES } from "@/data/site";

export const Hero = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="inici"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-center justify-center text-center overflow-hidden"
    >
      <img
        src={IMAGES.storefront}
        alt="Façana de la Pastisseria Solís a Calella"
        fetchpriority="high"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-[#2C1E16]/70" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        className="relative z-10 px-6 max-w-4xl"
      >
        <span className="inline-flex items-center gap-2 text-[#E9D7A8] text-xs sm:text-sm uppercase tracking-[0.3em] font-semibold mb-6">
          <MapPin size={15} /> Calella · Barcelona
        </span>
        <h1 className="font-display text-[#FDFBF7] text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.05] tracking-tight">
          Pastisseria <span className="italic text-[#E9D7A8]">Solís</span>
        </h1>
        <p className="mt-6 text-[#FDFBF7]/90 text-lg sm:text-xl max-w-2xl mx-auto leading-relaxed">
          Pastisseria artesana des de 1965. Brioixeria, pans i pastissos
          elaborats a mà cada dia, amb la recepta de sempre.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            data-testid="hero-products-btn"
            onClick={() => go("productes")}
            className="group inline-flex items-center gap-2 rounded-full bg-[#8B0000] text-[#FDFBF7] px-8 py-4 font-semibold hover:-translate-y-1 hover:shadow-2xl transition-all"
          >
            Veure productes
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid="hero-contact-btn"
            onClick={() => go("contacte")}
            className="inline-flex items-center gap-2 rounded-full border border-[#FDFBF7]/40 text-[#FDFBF7] px-8 py-4 font-semibold hover:bg-[#FDFBF7]/10 transition-all"
          >
            Contacte
          </button>
        </div>
      </motion.div>

      <div className="absolute bottom-6 inset-x-0 flex justify-center z-10">
        <span className="text-[#FDFBF7]/70 text-xs uppercase tracking-[0.3em]">
          {BUSINESS.address}
        </span>
      </div>
    </section>
  );
};
